// Shared dimension validation helpers for Division 8 numeric inputs.
// Rule: dimensional fields (Width/Height/RO Width/RO Height, etc.) accept
// only positive values (> 0). Empty/null values are considered "not provided"
// and pass (optional fields). Zero and negative values are rejected.

/**
 * Returns true when value is empty (optional) OR parses to a number > 0.
 * Returns false for 0, negative numbers, or non-numeric strings.
 */
export const isValidPositiveDimension = (value) => {
  if (value === '' || value === null || value === undefined) return true;
  const n = parseFloat(value);
  return !isNaN(n) && n > 0;
};

/**
 * Validates a map of { "Field Label": value } pairs.
 * Returns the first error message found, or null when all values are valid.
 */
export const validatePositiveDimensions = (fields) => {
  for (const [label, value] of Object.entries(fields)) {
    if (value === '' || value === null || value === undefined) continue;
    const n = parseFloat(value);
    if (isNaN(n) || n <= 0) {
      return `${label} must be greater than 0`;
    }
  }
  return null;
};
